import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname, search } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    // Don't scroll to top when navigating between solutions page and its subsections
    // BUT DO scroll if coming from a different page
    const isSolutionsNavigation =
      pathname === '/solutions' &&
      prevPathnameRef.current === '/solutions' &&
      (search.includes('solution=') || !search);

    // Only scroll to top if it's not solutions navigation
    if (!isSolutionsNavigation) {
      // Force an instant jump on route change so navigation stays snappy,
      // independent of the global smooth scroll-behavior used for anchor links.
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' as ScrollBehavior });
    }

    // Update ref for next navigation
    prevPathnameRef.current = pathname;
  }, [pathname, search]);

  return null;
}